var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const initMainCollection = /* @__PURE__ */ __name(($el, current_sort) => {
  const gridContainer = /* @__PURE__ */ __name(() => $el.querySelector("[data-next-url]"), "gridContainer");
  // state.count has two consumers: the "showing [count] of [total]" line under 'manual'
  // pagination, and the Empty State block, which renders itself when count <= 0. It used to be
  // container.children.length, which also counted the Bundle & Save banner's display:contents
  // wrapper and the auto-load sentinel -- an over-count of up to 2. Under 'manual' that hid the
  // "load more" button early, and now that _main_collection__product_cards drops sold-out
  // products entirely it would be worse: a collection where every product is sold out renders
  // zero cards but two non-card children, so the Empty State would never fire and the shopper
  // would get a blank grid. Count the cards themselves, direct children only so nothing nested
  // inside the banner is mistaken for one. Still undefined (not 0) when there is no grid at all,
  // so a section with the cards block removed doesn't start claiming to be empty.
  const countCards = /* @__PURE__ */ __name(
    (container = gridContainer()) => container ? container.querySelectorAll(":scope > [data-product-handle]").length : void 0,
    "countCards"
  );
  // Bound on the sentinel's chain-load -- see autoLoadNextPage. 6 pages of the default
  // pagination size is ~144 consecutive sold-out products before we stop pulling.
  const MAX_FRUITLESS_AUTO_LOADS = 6;
  const state = window.Alpine.reactive({
    loading: false,
    count: countCards(),
    fruitless_loads: 0,
    sort_by: current_sort,
    next_url: $el.querySelector("[data-next-url]")?.getAttribute("data-next-url")
  });
  const modalStore = window.Alpine.store("modal");
  Alpine.effect(() => {
    if (state.sort_by !== current_sort) {
      Alpine.nextTick(() => {
        updateSortAndFilters();
      });
    }
  });
  const updateSortAndFilters = /* @__PURE__ */ __name(async (url = new URL(`${$el.action?.split("?")[0]}?${new URLSearchParams(new FormData($el)).toString()}`)) => {
    modalStore.setId("");
    state.loading = true;
    $el?.querySelectorAll(
      "[class^=product-card--], [class^=collection-card--], [class^=article-card--], [class^=blog-card--], [class^=page-card--]"
    )?.forEach((card) => {
      card?.classList?.add("button-loading-transparent");
    });
    const content = await fetch(url).then((res) => res.text());
    url?.searchParams?.delete("barba_prefetch");
    barba.history.add(url.toString(), "barba", "replace");
    const newDocument = document.createElement("div");
    newDocument.innerHTML = content;
    const section = newDocument.querySelector(`[data-style-id="${$el.getAttribute("data-style-id")}"]`);
    $el.outerHTML = section.outerHTML;
    state.loading = false;
    state.fruitless_loads = 0;
    state.count = countCards();
    const header = document.querySelector(".header-sections-container");
    const offsetHeight = Math.max(180, header?.getBoundingClientRect()?.bottom ?? 0);
    utils.scrollToY(150, utils.getElementPosition($el).top - offsetHeight - +getComputedStyle($el).paddingTop.replace("px", ""));
  }, "updateSortAndFilters");
  const debounceUpdates = utils.debounce(updateSortAndFilters, 750);
  const loadNextPage = /* @__PURE__ */ __name(async (container = $el.querySelector(`[data-next-url]`), paginationContainer = $el.querySelector(`[data-pagination][x-ref="pagination"]`)) => {
    // Serialisation guard. There is no await between reading state.loading and setting it, so
    // two callers in the same tick -- the sentinel's x-intersect and its x-effect both fire on
    // first paint -- can never both get past this line. That is what keeps the auto-loader from
    // firing a burst of parallel page fetches; every load is strictly one at a time.
    if (!state.next_url || state.loading) return 0;
    state.loading = true;
    let appended = 0;
    try {
      const styleId = $el.getAttribute("data-style-id");
      const sectionId = $el.closest(".shopify-section")?.id?.replace("shopify-section-", "");
      const buildUrl = (base) => sectionId ? base + (base.includes("?") ? "&" : "?") + "section_id=" + encodeURIComponent(sectionId) : base;
      let section = null;
      try {
        const html2 = await fetch(buildUrl(state.next_url)).then((res) => res.text());
        const doc2 = document.createElement("div");
        doc2.innerHTML = html2;
        section = doc2.querySelector(`[data-style-id="${styleId}"]`);
      } catch (e) {
        section = null;
      }
      if (!section) {
        try {
          const htmlFull = await fetch(state.next_url).then((res) => res.text());
          const docFull = document.createElement("div");
          docFull.innerHTML = htmlFull;
          section = docFull.querySelector(`[data-style-id="${styleId}"]`);
        } catch (e) {
          section = null;
        }
      }
      // Bail before touching next_url so a transient network failure doesn't permanently kill
      // pagination for this page view -- the caller can try again. Uncaught, this used to reject
      // the promise (an unhandled rejection out of the sentinel's x-effect) and leave loading
      // stuck true. The finally below counts this as a fruitless load, so repeated failures burn
      // the auto-load budget and the chain stops instead of hammering a broken endpoint.
      if (!section) return 0;
      const newContent = section?.querySelector(`[data-next-url][x-ref="${container?.getAttribute("x-ref")}"]`);
      state.next_url = newContent?.getAttribute("data-next-url");
      const newPagination = section?.querySelector(`[data-pagination][x-ref="pagination"]`);
      if (newContent) {
        const before = countCards(container);
        container.append(...newContent.children);
        state.count = countCards(container);
        appended = state.count - before;
      }
      if (paginationContainer && newPagination) {
        paginationContainer.innerHTML = newPagination.innerHTML;
      }
    } finally {
      // finally, not a tail assignment: if either fetch throws, loading has to come back down
      // or the section is wedged for good (no more auto-load, and the 'manual' button stays
      // disabled). A throw leaves appended at 0, so a failed load also burns auto-load budget
      // -- which is what stops the chain from retrying a broken endpoint forever.
      state.fruitless_loads = appended > 0 ? 0 : state.fruitless_loads + 1;
      state.loading = false;
    }
    return appended;
  }, "loadNextPage");
  // The sentinel chain-loads: its x-effect re-runs every time state.loading flips and pulls
  // again while the sentinel is still within 1200px of the fold, so a short screen keeps
  // filling without the shopper scrolling. Sold-out products are no longer rendered, so a page
  // of 24 can append 0 cards and leave the sentinel exactly where it was -- and a collection
  // with a long sold-out run would chain through every remaining page trying to fill a screen
  // it never fills. fruitless_loads bounds that: each chained load either appends a card (which
  // resets the budget AND pushes the sentinel further down the page, so this can only happen as
  // many times as there are in-stock products) or burns one, so the chain always terminates.
  // Deliberately NOT used by the sentinel's x-intersect: that fires once per enter transition,
  // so it is already bounded by the shopper's own scrolling and must never be refused.
  const autoLoadNextPage = /* @__PURE__ */ __name(async () => {
    if (state.fruitless_loads >= MAX_FRUITLESS_AUTO_LOADS) return 0;
    return loadNextPage();
  }, "autoLoadNextPage");
  return {
    main_collection: {
      state,
      loadNextPage,
      autoLoadNextPage,
      updateSortAndFilters,
      debounceUpdates
    }
  };
}, "initMainCollection");
window._sections["initMainCollection"] = initMainCollection;
